import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import * as i1 from '@angular/common/http';
import * as i2 from 'primeng/table';
import * as i3 from 'primeng/api';
import * as i4 from '@angular/common';
import { PrimengLibraryModule } from 'primeng-library';

class TimesheetSummaryService {
    constructor(http) {
        this.http = http;
        this.onLoadResponseSubject = new BehaviorSubject(null);
    }
    getTimehseetSummaryDetails(Id) {
        return this.http.get(`/vd/formBuilder/employee/approvalAttendance/${Id}/details`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
}
TimesheetSummaryService.ɵfac = function TimesheetSummaryService_Factory(t) { return new (t || TimesheetSummaryService)(i0.ɵɵinject(i1.HttpClient)); };
TimesheetSummaryService.ɵprov = i0.ɵɵdefineInjectable({ token: TimesheetSummaryService, factory: TimesheetSummaryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TimesheetSummaryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function TimesheetSummaryComponent_ng_template_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th");
    i0.ɵɵtext(2, "Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th");
    i0.ɵɵtext(4, "First In");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th");
    i0.ɵɵtext(6, "Late In");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th");
    i0.ɵɵtext(8, "Last Out");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th");
    i0.ɵɵtext(10, "Early Out");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th");
    i0.ɵɵtext(12, "First Half");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "th");
    i0.ɵɵtext(14, "Second Half");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "th");
    i0.ɵɵtext(16, "Standard Hours");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "th");
    i0.ɵɵtext(18, "Total Work Hours");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "th");
    i0.ɵɵtext(20, "OT");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c0 = function (a0) { return { "absent": a0 }; };
const _c1 = function (a0, a1) { return { "present": a0, "absent": a1 }; };
function TimesheetSummaryComponent_ng_template_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 11);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "td", 12);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "td");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "td", 12);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "td", 12);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "td", 12);
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "td");
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "td");
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "td");
    i0.ɵɵtext(21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rowData_r3 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 14, rowData_r3 == null ? null : rowData_r3.attendanceDate, "MM-dd-yyyy"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate((rowData_r3 == null ? null : rowData_r3.firstIn) ? rowData_r3 == null ? null : rowData_r3.firstIn : "--");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(17, _c0, rowData_r3 == null ? null : rowData_r3.lateInMins.toLowerCase().includes("minutes")));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate((rowData_r3 == null ? null : rowData_r3.lateInMins) ? rowData_r3 == null ? null : rowData_r3.lateInMins : "--");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((rowData_r3 == null ? null : rowData_r3.lastOut) ? rowData_r3 == null ? null : rowData_r3.lastOut : "--");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(19, _c0, rowData_r3 == null ? null : rowData_r3.earlyOutMins.toLowerCase().includes("minutes")));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate((rowData_r3 == null ? null : rowData_r3.earlyOutMins) ? rowData_r3 == null ? null : rowData_r3.earlyOutMins : "--");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(21, _c1, (rowData_r3 == null ? null : rowData_r3.firstHalf == null ? null : rowData_r3.firstHalf.name) == "Present", (rowData_r3 == null ? null : rowData_r3.firstHalf == null ? null : rowData_r3.firstHalf.name) == "Absent"));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate((rowData_r3 == null ? null : rowData_r3.firstHalf == null ? null : rowData_r3.firstHalf.name) ? rowData_r3 == null ? null : rowData_r3.firstHalf == null ? null : rowData_r3.firstHalf.name : "--");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(24, _c1, (rowData_r3 == null ? null : rowData_r3.secondHalf == null ? null : rowData_r3.secondHalf.name) == "Present", (rowData_r3 == null ? null : rowData_r3.secondHalf == null ? null : rowData_r3.secondHalf.name) == "Absent"));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate((rowData_r3 == null ? null : rowData_r3.secondHalf == null ? null : rowData_r3.secondHalf.name) ? rowData_r3 == null ? null : rowData_r3.secondHalf == null ? null : rowData_r3.secondHalf.name : "--");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((rowData_r3 == null ? null : rowData_r3.standardHoursStr) ? rowData_r3 == null ? null : rowData_r3.standardHoursStr : "--");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", (rowData_r3 == null ? null : rowData_r3.totalHoursStr) ? rowData_r3 == null ? null : rowData_r3.totalHoursStr : "--", "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", (rowData_r3 == null ? null : rowData_r3.overtimeStr) ? rowData_r3 == null ? null : rowData_r3.overtimeStr : "--", "");
} }
function TimesheetSummaryComponent_ng_template_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 13);
    i0.ɵɵtext(2, "No data available.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("colspan", 10);
} }
class TimesheetSummaryComponent {
    constructor(timesheetSummaryService) {
        this.timesheetSummaryService = timesheetSummaryService;
        this.observableSubscription$ = new Subject();
        this.getTimesheetSummaryList = [];
    }
    ngOnInit() {
        this.getTimehseetList();
    }
    getTimehseetList() {
        this.dataId = 'AttendanceDataId' in sessionStorage ? parseInt(sessionStorage.getItem('AttendanceDataId')) : null;
        if (this.dataId) {
            this.timesheetSummaryService.getTimehseetSummaryDetails(this.dataId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                if (response.data) {
                    this.getTimesheetSummaryList = response.data || null;
                    this.allTableValue = response.data.attendanceMarkedDetailsList || null;
                }
            });
        }
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
TimesheetSummaryComponent.ɵfac = function TimesheetSummaryComponent_Factory(t) { return new (t || TimesheetSummaryComponent)(i0.ɵɵdirectiveInject(TimesheetSummaryService)); };
TimesheetSummaryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: TimesheetSummaryComponent, selectors: [["timesheet-summary"]], decls: 28, vars: 5, consts: [[1, "container-fluid", "timesheet-summary", "p-0", "mt-2", "mb-2", "pb-3"], [1, "row"], [1, "col-3"], [1, "summary_details_heading", "m-0"], [1, "summary_details_content", "mb-4"], [1, "summary_details_content"], [1, "col-12"], ["styleClass", "p-datatable-striped", 1, "p-datatable-fb-forms", "pb-4", 3, "value"], ["pTemplate", "header"], ["pTemplate", "body"], ["pTemplate", "emptymessage"], [1, "displayDate"], [3, "ngClass"], [1, "text-center"]], template: function TimesheetSummaryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "p", 3);
        i0.ɵɵtext(4, " Employee Name: ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "p", 4);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 2);
        i0.ɵɵelementStart(8, "p", 3);
        i0.ɵɵtext(9, " Employee ID: ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "p", 5);
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 2);
        i0.ɵɵelementStart(13, "p", 3);
        i0.ɵɵtext(14, " Report: ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "p", 5);
        i0.ɵɵtext(16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "div", 2);
        i0.ɵɵelementStart(18, "p", 3);
        i0.ɵɵtext(19, " Working Hours: ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "p", 5);
        i0.ɵɵtext(21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div", 1);
        i0.ɵɵelementStart(23, "div", 6);
        i0.ɵɵelementStart(24, "p-table", 7);
        i0.ɵɵtemplate(25, TimesheetSummaryComponent_ng_template_25_Template, 21, 0, "ng-template", 8);
        i0.ɵɵtemplate(26, TimesheetSummaryComponent_ng_template_26_Template, 22, 27, "ng-template", 9);
        i0.ɵɵtemplate(27, TimesheetSummaryComponent_ng_template_27_Template, 3, 1, "ng-template", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1(" ", ctx.getTimesheetSummaryList.employeeName, " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", ctx.getTimesheetSummaryList.employeeId, " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", ctx.getTimesheetSummaryList.monthName, " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", ctx.getTimesheetSummaryList.totalWorkingHours, " ");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("value", ctx.allTableValue);
    } }, directives: [i2.Table, i3.PrimeTemplate, i4.NgClass], pipes: [i4.DatePipe], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TimesheetSummaryComponent, [{
        type: Component,
        args: [{
                selector: 'timesheet-summary',
                templateUrl: 'timesheet-summary.component.html',
                styleUrls: ['timesheet-summary.component.scss']
            }]
    }], function () { return [{ type: TimesheetSummaryService }]; }, null); })();

class TimesheetSummaryModule {
}
TimesheetSummaryModule.ɵfac = function TimesheetSummaryModule_Factory(t) { return new (t || TimesheetSummaryModule)(); };
TimesheetSummaryModule.ɵmod = i0.ɵɵdefineNgModule({ type: TimesheetSummaryModule });
TimesheetSummaryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(TimesheetSummaryModule, { declarations: [TimesheetSummaryComponent], imports: [PrimengLibraryModule], exports: [TimesheetSummaryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TimesheetSummaryModule, [{
        type: NgModule,
        args: [{
                declarations: [TimesheetSummaryComponent],
                imports: [
                    PrimengLibraryModule
                ],
                exports: [TimesheetSummaryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of timesheet-summary
 */

/**
 * Generated bundle index. Do not edit.
 */

export { TimesheetSummaryComponent, TimesheetSummaryModule, TimesheetSummaryService };
//# sourceMappingURL=timesheet-summary.js.map
